import React from 'react';
import { connect } from 'react-redux'
import NuevaSolicitudTarjeta from './NuevaSolicitudTarjeta';

//Importación de actions.
import {
    closeModal,
    getScreenData,
    openDays,
    guardarSolicitudBorrador,
    //saveRequest,
    countCard,
    getHeadline,
    getKind,
    getLimit,
    getDays,
    getDenomination,
    routingNext,
    routingPrevious,
    routeToCancel,
    changeToSelectCard,
    editDate,
    deleteDate,
    searchTitular,
    showError,
    showErrorData,
    routeToLimits,
    validateAlphaOnly,
    resetStateSolicitudConfirmacion,
    routeToNuevaSolicitudConfirmacion,
    openModalDistribucionLimites,
    closeModalDistribucionLimites,
    actualizarLimites,
    resetStateSolicitudTarjeta,
    validateAddCard,
    seleccionarCodigoDistribucion
} from '../actions/NuevaSolicitudTarjetaActions';

//Mapeo del state
const mapStateToProps = (state) => {
    return {
        data: state.nuevaSolicitudTarjeta,
        tarjetas: state.tarjetas
    }
}

//Mapeo de las actions en las props
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getScreenData: (currentScope) => {
            dispatch(getScreenData(currentScope));
        },
        validateAddCard: (dataCard, form) => {
            dispatch(validateAddCard(dataCard, form));
        },
        openDays: () => {
            dispatch(openDays());
        },
        //saveRequest: () => {
        //    dispatch(saveRequest());
        //},
        countCard: () => {
            dispatch(countCard());
        },
        getHeadline: (headline, tipoDocumento) => {
            dispatch(getHeadline(headline, tipoDocumento));
        },
        getKind: (kind) => {
            dispatch(getKind(kind));
        },
        getLimit: (limit) => {
            dispatch(getLimit(limit));
        },
        getDays: (idDays) => {
            dispatch(getDays(idDays));
        },
        getDenomination: (idDenom) => {
            dispatch(getDenomination(idDenom));
        },
        routingNext: () => {
            dispatch(routingNext());
        },
        routingPrevious: () => {
            dispatch(routingPrevious());
        },
        routeToCancel: () => {
            dispatch(routeToCancel());
        },
        changeToSelectCard: () => {
            dispatch(changeToSelectCard());
        },
        editDate: (row) => {
            dispatch(editDate(row));
        },
        deleteDate: (id) => {
            dispatch(deleteDate(id));
        },
        searchTitular: (search) => {
            dispatch(searchTitular(search));
        },
        showError: () => {
            dispatch(showError());
        },
        showErrorData: () => {
            dispatch(showErrorData());
        },
        routeToLimits: () => {
            dispatch(routeToLimits());
        },
        validateAlphaOnly: (denomination, isValid) => {
            dispatch(validateAlphaOnly(denomination, isValid));
        },
        resetStateSolicitudTarjeta: () => {
            dispatch(resetStateSolicitudTarjeta());
        },
        routeToNuevaSolicitudConfirmacion: () => {
            dispatch(routeToNuevaSolicitudConfirmacion());
        },
        closeModal: () => {
            closeModal();
        },
        guardarSolicitudBorrador: () => {
            dispatch(guardarSolicitudBorrador());
        },
        openModalDistribucionLimites: () => {
            dispatch(openModalDistribucionLimites());
        },
        closeModalDistribucionLimites: () => {
            dispatch(closeModalDistribucionLimites());
        },
        actualizarLimites: (estado) => {
            dispatch(actualizarLimites(estado));
        },
        resetStateSolicitudTarjeta: () => {
            dispatch(resetStateSolicitudTarjeta());
        },
        seleccionarCodigoDistribucion: (codigo, id) => {
            dispatch(seleccionarCodigoDistribucion(codigo, id));
        }
    }
}

//Connect entre el componente y las props y actions.
const NuevaSolicitudTarjetaContainer = connect(mapStateToProps, mapDispatchToProps)(NuevaSolicitudTarjeta);

export default NuevaSolicitudTarjetaContainer;